module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-hero4.png?20ddb264";